/* eslint-disable @typescript-eslint/no-explicit-any */
import backendApi from "./backendApi";
import { showSnackbar } from "./snackbar.service";

const routePrefix = "assets";

export default {
  async checkFileExistence({
    files,
    location,
    companyId,
  }: {
    files: { fileName: string; size: number }[];
    location: string;
    companyId?: string;
  }): Promise<any> {
    try {
      const result = await backendApi()?.post(
        `${routePrefix}/check-existence`,
        {
          files,
          location,
          companyId,
        }
      );
      return result?.data || [];
    } catch (error: any) {
      if (error?.response?.status) {
        showSnackbar(
          "danger",
          "Error",
          error?.response?.data?.message || "Could not check whether that file exists."
        );
        return null;
      }
      return [];
    }
  },
  async uploadFile({
    blob,
    fileName,
    location,
    directory,
    companyId,
  }: {
    blob: Blob;
    fileName?: string;
    location?: string;
    directory?: string;
    companyId?: string;
  }): Promise<any> {
    try {
      const formData = new FormData();
      formData.append("image", blob);

      const result = await backendApi()?.post(
        `${routePrefix}/upload/${fileName}?location=${
          location || ""
        }&directory=${directory || ""}&companyId=${companyId || ""}`,
        formData
      );
      if (result?.status != 200) {
        showSnackbar(
          "danger",
          "Error",
          result?.data.message || "Could not save the file."
        );
        return null;
      }
      return result?.data?.s3Url || "";
    } catch (error: any) {
      if (error?.response?.status) {
        showSnackbar(
          "danger",
          "Error",
          error?.response?.data?.message || "Could not save the file."
        );
        return null;
      }
    }
  },
  async fetchFileBlob({
    fileName,
    location,
    companyId,
  }: {
    fileName: string;
    location?: string;
    companyId?: string;
  }): Promise<Blob | null> {
    try {
      const response = await backendApi()?.get(
        `${routePrefix}/download/${encodeURIComponent(fileName)}?location=${
          location || ""
        }${companyId ? `&companyId=${companyId}` : ""}`,
        {
          responseType: "blob",
        }
      );
      return response?.data || null;
    } catch (error: any) {
      return null;
    }
  },
  async downloadFile({
    fileName,
    location,
    companyId,
  }: {
    fileName: string;
    location?: string;
    companyId?: string;
  }) {
    try {
      const response = await backendApi()?.get(
        `${routePrefix}/download/${encodeURIComponent(fileName)}?location=${
          location || ""
        }${companyId ? `&companyId=${companyId}` : ""}`,
        {
          responseType: "blob",
        }
      );
      if (response.data) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          fileName.split("/")[fileName.split("/").length - 1]
        );
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        link.remove();
      }
    } catch (error: any) {
      showSnackbar(
        "danger",
        "Error",
        error?.response?.status == 403
          ? "You are not authorized to download this file"
          : error?.response?.data?.message || "Could not download the file."
      );
      return null;
    }
  },
};
